export default __webpack_public_path__ + "images/0f649b1350eaaff81b7ed5e4c00e0dc6.svg";